import React from "react";
import DrpEeduHeader from "../../components/DrpEeduHeader";
import DrpEduNavbar from "../../components/DrpEduNavbar";
import Footer from "../../components/Footer";

const KazakhstanMbbs = () => {
  return (
    <>
      <DrpEeduHeader />
      <DrpEduNavbar />{" "}
      <div className="mbbs-country-page">
        <section className="country-header">
          <h2 className="country-title">🩺 MBBS in Kazakhstan</h2>
        </section>

        <section className="details-section">
          <div className="detail-item">
            <h3 className="detail-title">Degree Awarded:</h3>
            <p className="detail-text">
              MD (Doctor of Medicine) — equivalent to MBBS in India
            </p>
          </div>
          <div className="detail-item">
            <h3 className="detail-title">Duration:</h3>
            <p className="detail-text">5 years</p>
          </div>
          <div className="detail-item">
            <h3 className="detail-title">Eligibility:</h3>
            <ul className="detail-list">
              <li>10+2 with Physics, Chemistry, Biology, and English</li>
              <li>Minimum 50% marks in PCB</li>
              <li>NEET qualification mandatory (for Indian students)</li>
            </ul>
          </div>
          <div className="detail-item">
            <h3 className="detail-title">Medium of Instruction:</h3>
            <p className="detail-text">English</p>
          </div>
          <div className="detail-item">
            <h3 className="detail-title">Recognition:</h3>
            <p className="detail-text">NMC (India), WHO, WFME, ECFMG</p>
          </div>
          <div className="detail-item">
            <h3 className="detail-title">Advantages:</h3>
            <p className="detail-text">
              Low tuition costs, NMC-approved curriculum, Indian food available.
            </p>
          </div>
        </section>

        <section className="universities-section">
          <h2 className="section-title">
            🎓 Top Medical Universities in Kazakhstan
          </h2>
          <div className="university-list">
            <div className="university-card">
              <h3 className="university-name">
                Kazakh National Medical University (KazNMU), Almaty
              </h3>
              <p className="university-description">
                Most prestigious and oldest medical university in Kazakhstan.
                NMC, WHO, and WFME recognized.
              </p>
            </div>
            <div className="university-card">
              <h3 className="university-name">
                Astana Medical University, Astana (Nur-Sultan)
              </h3>
              <p className="university-description">
                Government university with modern infrastructure and clinical
                training. High international student intake.
              </p>
            </div>
            <div className="university-card">
              <h3 className="university-name">
                Karaganda State Medical University (KSMU), Karaganda
              </h3>
              <p className="university-description">
                Popular among Indian students. Offers affordable MBBS with good
                clinical exposure.
              </p>
            </div>
            <div className="university-card">
              <h3 className="university-name">
                South Kazakhstan Medical Academy (SKMA), Shymkent
              </h3>
              <p className="university-description">
                Government university. English-medium programs, NMC approved.
              </p>
            </div>
            <div className="university-card">
              <h3 className="university-name">
                Semey State Medical University, Semey
              </h3>
              <p className="university-description">
                Known for experienced faculty and international recognition.
                Recognized by WHO and NMC.
              </p>
            </div>
            <div className="university-card">
              <h3 className="university-name">
                West Kazakhstan Marat Ospanov State Medical University, Aktobe
              </h3>
              <p className="university-description">
                Offers full English-medium MBBS. Good facilities and hostel
                support for international students.
              </p>
            </div>
            <div className="university-card">
              <h3 className="university-name">
                North Kazakhstan State University (NKSU), Petropavl
              </h3>
              <p className="university-description">
                Rising in popularity among foreign students. Affordable and NMC
                approved.
              </p>
            </div>
          </div>
        </section>
      </div>
      <Footer />
    </>
  );
};

export default KazakhstanMbbs;
